/**
 * SmartdineNow API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Observable } from 'rxjs';

import { MenuItemMapStockEntity } from '../model/menuItemMapStockEntity';
import { SmartDineResponseMenuItemMapStockEntity } from '../model/smartDineResponseMenuItemMapStockEntity';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';


@Injectable()
export class MenuItemMapStockRestControllerService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param menuItemMapId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createMenuItemMapStock(body: MenuItemMapStockEntity, restaurantId: string, restaurantBranchId: string, menuItemMapId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseMenuItemMapStockEntity>;
    public createMenuItemMapStock(body: MenuItemMapStockEntity, restaurantId: string, restaurantBranchId: string, menuItemMapId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseMenuItemMapStockEntity>>;
    public createMenuItemMapStock(body: MenuItemMapStockEntity, restaurantId: string, restaurantBranchId: string, menuItemMapId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseMenuItemMapStockEntity>>;
    public createMenuItemMapStock(body: MenuItemMapStockEntity, restaurantId: string, restaurantBranchId: string, menuItemMapId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createMenuItemMapStock.');
        }

        if (restaurantId === null || restaurantId === undefined) {
            throw new Error('Required parameter restaurantId was null or undefined when calling createMenuItemMapStock.');
        }

        if (restaurantBranchId === null || restaurantBranchId === undefined) {
            throw new Error('Required parameter restaurantBranchId was null or undefined when calling createMenuItemMapStock.');
        }

        if (menuItemMapId === null || menuItemMapId === undefined) {
            throw new Error('Required parameter menuItemMapId was null or undefined when calling createMenuItemMapStock.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (restaurantId !== undefined && restaurantId !== null) {
            queryParameters = queryParameters.set('restaurantId', <any>restaurantId);
        }
        if (restaurantBranchId !== undefined && restaurantBranchId !== null) {
            queryParameters = queryParameters.set('restaurantBranchId', <any>restaurantBranchId);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SmartDineResponseMenuItemMapStockEntity>('post',`${this.basePath}/api/admin/menuitemmaps/${encodeURIComponent(String(menuItemMapId))}/stocks`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param menuItemMapId 
     * @param menuItemMapStockId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteMenuItemMapStock(restaurantId: string, restaurantBranchId: string, menuItemMapId: string, menuItemMapStockId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseMenuItemMapStockEntity>;
    public deleteMenuItemMapStock(restaurantId: string, restaurantBranchId: string, menuItemMapId: string, menuItemMapStockId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseMenuItemMapStockEntity>>;
    public deleteMenuItemMapStock(restaurantId: string, restaurantBranchId: string, menuItemMapId: string, menuItemMapStockId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseMenuItemMapStockEntity>>;
    public deleteMenuItemMapStock(restaurantId: string, restaurantBranchId: string, menuItemMapId: string, menuItemMapStockId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (restaurantId === null || restaurantId === undefined) {
            throw new Error('Required parameter restaurantId was null or undefined when calling deleteMenuItemMapStock.');
        }

        if (restaurantBranchId === null || restaurantBranchId === undefined) {
            throw new Error('Required parameter restaurantBranchId was null or undefined when calling deleteMenuItemMapStock.');
        }

        if (menuItemMapId === null || menuItemMapId === undefined) {
            throw new Error('Required parameter menuItemMapId was null or undefined when calling deleteMenuItemMapStock.');
        }

        if (menuItemMapStockId === null || menuItemMapStockId === undefined) {
            throw new Error('Required parameter menuItemMapStockId was null or undefined when calling deleteMenuItemMapStock.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (restaurantId !== undefined && restaurantId !== null) {
            queryParameters = queryParameters.set('restaurantId', <any>restaurantId);
        }
        if (restaurantBranchId !== undefined && restaurantBranchId !== null) {
            queryParameters = queryParameters.set('restaurantBranchId', <any>restaurantBranchId);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseMenuItemMapStockEntity>('delete',`${this.basePath}/api/admin/menuitemmaps/${encodeURIComponent(String(menuItemMapId))}/stocks/${encodeURIComponent(String(menuItemMapStockId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param menuItemMapId 
     * @param menuItemMapStockId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMenuItemMapStock(restaurantId: string, restaurantBranchId: string, menuItemMapId: string, menuItemMapStockId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseMenuItemMapStockEntity>;
    public getMenuItemMapStock(restaurantId: string, restaurantBranchId: string, menuItemMapId: string, menuItemMapStockId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseMenuItemMapStockEntity>>;
    public getMenuItemMapStock(restaurantId: string, restaurantBranchId: string, menuItemMapId: string, menuItemMapStockId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseMenuItemMapStockEntity>>;
    public getMenuItemMapStock(restaurantId: string, restaurantBranchId: string, menuItemMapId: string, menuItemMapStockId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (restaurantId === null || restaurantId === undefined) {
            throw new Error('Required parameter restaurantId was null or undefined when calling getMenuItemMapStock.');
        }

        if (restaurantBranchId === null || restaurantBranchId === undefined) {
            throw new Error('Required parameter restaurantBranchId was null or undefined when calling getMenuItemMapStock.');
        }

        if (menuItemMapId === null || menuItemMapId === undefined) {
            throw new Error('Required parameter menuItemMapId was null or undefined when calling getMenuItemMapStock.');
        }

        if (menuItemMapStockId === null || menuItemMapStockId === undefined) {
            throw new Error('Required parameter menuItemMapStockId was null or undefined when calling getMenuItemMapStock.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (restaurantId !== undefined && restaurantId !== null) {
            queryParameters = queryParameters.set('restaurantId', <any>restaurantId);
        }
        if (restaurantBranchId !== undefined && restaurantBranchId !== null) {
            queryParameters = queryParameters.set('restaurantBranchId', <any>restaurantBranchId);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseMenuItemMapStockEntity>('get',`${this.basePath}/api/admin/menuitemmaps/${encodeURIComponent(String(menuItemMapId))}/stocks/${encodeURIComponent(String(menuItemMapStockId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param menuItemMapId 
     * @param date 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMenuItemMapStocks(restaurantId: string, restaurantBranchId: string, menuItemMapId: string, date?: Date, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseMenuItemMapStockEntity>;
    public getMenuItemMapStocks(restaurantId: string, restaurantBranchId: string, menuItemMapId: string, date?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseMenuItemMapStockEntity>>;
    public getMenuItemMapStocks(restaurantId: string, restaurantBranchId: string, menuItemMapId: string, date?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseMenuItemMapStockEntity>>;
    public getMenuItemMapStocks(restaurantId: string, restaurantBranchId: string, menuItemMapId: string, date?: Date, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (restaurantId === null || restaurantId === undefined) {
            throw new Error('Required parameter restaurantId was null or undefined when calling getMenuItemMapStocks.');
        }

        if (restaurantBranchId === null || restaurantBranchId === undefined) {
            throw new Error('Required parameter restaurantBranchId was null or undefined when calling getMenuItemMapStocks.');
        }

        if (menuItemMapId === null || menuItemMapId === undefined) {
            throw new Error('Required parameter menuItemMapId was null or undefined when calling getMenuItemMapStocks.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (restaurantId !== undefined && restaurantId !== null) {
            queryParameters = queryParameters.set('restaurantId', <any>restaurantId);
        }
        if (restaurantBranchId !== undefined && restaurantBranchId !== null) {
            queryParameters = queryParameters.set('restaurantBranchId', <any>restaurantBranchId);
        }
        if (date !== undefined && date !== null) {
            queryParameters = queryParameters.set('date', <any>date.toISOString());
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseMenuItemMapStockEntity>('get',`${this.basePath}/api/admin/menuitemmaps/${encodeURIComponent(String(menuItemMapId))}/stocks`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param menuItemMapId 
     * @param menuItemMapStockId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateMenuItemMapStock(body: MenuItemMapStockEntity, restaurantId: string, restaurantBranchId: string, menuItemMapId: string, menuItemMapStockId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseMenuItemMapStockEntity>;
    public updateMenuItemMapStock(body: MenuItemMapStockEntity, restaurantId: string, restaurantBranchId: string, menuItemMapId: string, menuItemMapStockId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseMenuItemMapStockEntity>>;
    public updateMenuItemMapStock(body: MenuItemMapStockEntity, restaurantId: string, restaurantBranchId: string, menuItemMapId: string, menuItemMapStockId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseMenuItemMapStockEntity>>;
    public updateMenuItemMapStock(body: MenuItemMapStockEntity, restaurantId: string, restaurantBranchId: string, menuItemMapId: string, menuItemMapStockId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateMenuItemMapStock.');
        }

        if (restaurantId === null || restaurantId === undefined) {
            throw new Error('Required parameter restaurantId was null or undefined when calling updateMenuItemMapStock.');
        }

        if (restaurantBranchId === null || restaurantBranchId === undefined) {
            throw new Error('Required parameter restaurantBranchId was null or undefined when calling updateMenuItemMapStock.');
        }

        if (menuItemMapId === null || menuItemMapId === undefined) {
            throw new Error('Required parameter menuItemMapId was null or undefined when calling updateMenuItemMapStock.');
        }

        if (menuItemMapStockId === null || menuItemMapStockId === undefined) {
            throw new Error('Required parameter menuItemMapStockId was null or undefined when calling updateMenuItemMapStock.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (restaurantId !== undefined && restaurantId !== null) {
            queryParameters = queryParameters.set('restaurantId', <any>restaurantId);
        }
        if (restaurantBranchId !== undefined && restaurantBranchId !== null) {
            queryParameters = queryParameters.set('restaurantBranchId', <any>restaurantBranchId);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SmartDineResponseMenuItemMapStockEntity>('put',`${this.basePath}/api/admin/menuitemmaps/${encodeURIComponent(String(menuItemMapId))}/stocks/${encodeURIComponent(String(menuItemMapStockId))}`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
